import React from 'react';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Navigate,
    Route,
} from 'react-router-dom';

import LoginPage from '../pages/auth/LoginPage';
import SystemUsersPage from '../pages/users/SystemUsersPage';
import PriceChangeLayout from '../components/layouts/PriceChangeLayout';
import TeamsPage from '../pages/teams/TeamsPage';
import HomePage from '../pages/price-change/home/HomePage';
import RequestsPage from '../pages/price-change/requests/RequestsPage';
import MasterDataImportErrors from '../pages/price-change/errors/MasterDataImportErrors';
import RestrictedSkuUploadPage from '../pages/price-change/upload/RestrictedSkuUploadPage';
import SystemMaintenancePage from '../pages/SystemMaintenancePage';
import Dashboard from '../pages/dashboard';
import StandInManagementLayout from '../components/layouts/StandInManagementLayout';
import StandInHomePage from '../pages/stand-in/StandInHomePage';
import NavigateToSelectedModule from '../components/navigation/NavigateToSelectedModule';
import StandInCalendarPage from '../pages/stand-in/StandInCalendarPage';
import OldDashboardPriceChangeRequestRedirect from './OldDashboardPriceChangeRequestRedirect';
import MaintenanceToolsPage from '../pages/maintenance-tools/MaintenanceTools';
import MaintenanceToolsLayout from '../components/layouts/MaintenanceToolsLayout';
import SalesReviewActivityPage from '../pages/sales-activity/SalesReviewActivityPage';
import PriceSurveysLayout from '../components/layouts/PriceSurveysLayout';
import PriceSurveysHome from '../pages/price-surveys/home/PriceSurveysHomePage';
import SurveyDetailsPage from '../pages/price-surveys/survey/SurveyDetailsPage';
import PriceSurveysUploadPage from '../pages/price-surveys/upload/PriceSurveysUploadPage';
import PricingBatchesHomePage from '../pages/pricing-batches/home/PricingBatchesHomePage';
import TrainingLayout from '../components/layouts/TrainingLayout';
import TrainingMaterialsPage from '../pages/training/materials/TrainingMaterialsPage';
import TrainingUploadPage from '../pages/training/upload/TrainingUploadPage';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<SystemMaintenancePage />}>
            <Route path="" element={<NavigateToSelectedModule />} />
            <Route path="auth">
                <Route path="login" element={<LoginPage />} />
            </Route>
            <Route path="dashboard">
                <Route
                    path="teams"
                    element={<Navigate to="/organisation-hireacrchy" />}
                />
                <Route
                    path="users"
                    element={<Navigate to="/user-management" />}
                />
                <Route
                    path="requests"
                    element={<OldDashboardPriceChangeRequestRedirect />}
                />
                <Route path="" element={<Dashboard />} />
                <Route path="*" element={<Dashboard />} />
            </Route>
            <Route path="price-change" element={<PriceChangeLayout />}>
                <Route path="" element={<HomePage />} />
                <Route path="home" element={<HomePage />} />
                <Route path="requests" element={<RequestsPage />} />
                <Route
                    path="pricing-batches"
                    element={<PricingBatchesHomePage />}
                />
                <Route
                    path="master-data-import-errors"
                    element={<MasterDataImportErrors />}
                />
                <Route path="upload" element={<RestrictedSkuUploadPage />} />
            </Route>
            <Route path="user-management" element={<SystemUsersPage />} />
            <Route path="organisation-hierarchy">
                <Route path="" element={<TeamsPage />} />
                <Route
                    path="sales-activity/:userId"
                    element={<SalesReviewActivityPage />}
                />
            </Route>
            <Route
                path="stand-in-management"
                element={<StandInManagementLayout />}
            >
                <Route path="" element={<StandInHomePage />} />
                <Route path="calendar" element={<StandInCalendarPage />} />
            </Route>
            <Route
                path="maintenance-tools"
                element={<MaintenanceToolsLayout />}
            >
                <Route path="" element={<MaintenanceToolsPage />} />
            </Route>
            <Route path="price-surveys" element={<PriceSurveysLayout />}>
                <Route path="" element={<PriceSurveysHome />} />
                <Route path="home" element={<PriceSurveysHome />} />
                <Route path="upload" element={<PriceSurveysUploadPage />} />
                <Route
                    path="survey/:surveyId"
                    element={<SurveyDetailsPage />}
                />
            </Route>
            <Route path="training" element={<TrainingLayout />}>
                <Route path="" element={<Navigate to="materials" replace />} />
                <Route path="materials" element={<TrainingMaterialsPage />} />
                <Route path="upload" element={<TrainingUploadPage />} />
            </Route>
            <Route path="*" element={<NavigateToSelectedModule />} />
        </Route>,
    ),
);

export default router;
